<script lang="tsx" setup>
import { cleanHTML } from "@/utils/clean"
import TextLabel from "../Text/TextLabel.vue"

defineProps<{
  name?: string
  subtitle?: string
}>()
</script>

<template>
  <div>
    <div v-if="name" v-html="cleanHTML(name)"></div>
    <div v-if="subtitle" class="italic" v-html="cleanHTML(subtitle)"></div>
  </div>
</template>
